import axios, { AxiosError } from "axios";
import LoginApi from "./loginApi";

type FailedRequestsQueueProps = {
  resolve(token: string): void;
  reject(err: AxiosError): void;
};

const baseUrl = axios.create({
  baseURL: "https://infocliente-api.automafour.com.br/api",
  // baseURL: "http://localhost:8080/api"
});

// Adiciona um interceptor de solicitação para adicionar o token
baseUrl.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("AcessToken");

    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

let IsRefresh = false;
let requests: FailedRequestsQueueProps[] = [];

// Confere a reposta para tratar erros de token
baseUrl.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401 && error.config?.url !== "/refresh") {
      const headers = error.config;
      const refresh = localStorage.getItem("RefreshToken");

      if (!IsRefresh) {
        IsRefresh = true;
        LoginApi.get("/refresh", {
          headers: {
            Authorization: `Bearer ${refresh}`,
          },
        })
          .then(async (response) => {
            localStorage.setItem("AcessToken", response.data.access);

            requests.forEach((request) =>
              request.resolve(response.data.access)
            );
            requests = [];
          })
          .catch((error) => {
            requests.forEach((request) => request.reject(error));
            requests = [];
            return (window.location.href = "/");
          })
          .finally(() => {
            IsRefresh = false;
          });
      }

      return new Promise((resolve, reject) => {
        requests.push({
          resolve: (token: string) => {
            if (headers?.headers) {
              headers.headers["Authorization"] = `${token}`;
              resolve(baseUrl(headers));
            }
          },
          reject: (err: AxiosError) => {
            reject(err);
          },
        });
      });
    }
    return Promise.reject(error);
  }
);

export default baseUrl;
